import { languageMap } from "../core"
import { bracketIndenting } from "./shared"

languageMap.kts = languageMap.kt = languageMap.kotlin = bracketIndenting()
